import {
  type FormHTMLAttributes,
  forwardRef,
  type PropsWithChildren,
  type RefAttributes,
} from 'react'

import { cn } from '@mntn-dev/ui-utilities'

import { getTestProps, type TestIds } from '../../utils/testing.ts'
import { FormContainer } from './form-container.tsx'
import { FormLayout } from './form-layout.tsx'
import { FormSection } from './form-section.tsx'
import { FormSectionTitle } from './form-section-title.tsx'

type FormProps = PropsWithChildren<
  Readonly<
    TestIds &
      RefAttributes<HTMLFormElement> &
      FormHTMLAttributes<HTMLFormElement> & {
        gap?: string
        ignoreInLayout?: boolean
      }
  >
>

const FormComponent = forwardRef<HTMLFormElement, FormProps>(
  (
    {
      children,
      dataTestId,
      dataTrackingId,
      className,
      ignoreInLayout,
      ...formProps
    },
    ref
  ) => (
    <form
      ref={ref}
      {...formProps}
      {...getTestProps({ dataTestId, dataTrackingId })}
      className={cn(
        'w-full h-full overflow-hidden',
        ignoreInLayout && cn('contents', className)
      )}
    >
      {ignoreInLayout ? (
        children
      ) : (
        <FormContainer className={className}>{children}</FormContainer>
      )}
    </form>
  )
)

const FormNamespace = Object.assign(FormComponent, {
  Container: FormContainer,
  Layout: FormLayout,
  Section: FormSection,
  SectionTitle: FormSectionTitle,
})

export { FormNamespace as Form, type FormProps }
